import Flex from '~/common/components/Flex';
import Text from '~/common/components/Texts/Text';

export type HeadingAndTextProps = {
  heading: string;
  text?: string | string[];
};

export default function HeadingAndText({
  heading,
  text = '',
}: Readonly<HeadingAndTextProps>) {
  let description = <Text data-testid={`single-text`}>{text}</Text>;
  if (Array.isArray(text)) {
    description = (
      <Text>
        {text.map((el) => (
          <Text
            data-testid="many-text"
            key={`${el}`}
            p={0}
            m={0}
            as="span"
            display="block"
          >
            {el}
          </Text>
        ))}
      </Text>
    );
  }

  return (
    <Flex marginY={2}>
      <Text as="h3" data-testid={`heading`} mr={1}>
        {heading}
      </Text>

      {description}
    </Flex>
  );
}
